import type { NavGroup } from './nav-items';

/**
 * The nav an employee sees: items whose permission they do not hold are
 * dropped, then any group left empty, so no one meets a `Security` heading with
 * nothing under it.
 *
 * Exact match, like the BFF's guard. This is presentation only: a hidden item
 * is still refused by the server if someone types its URL.
 */
export function visibleNavGroups(
    groups: readonly NavGroup[],
    permissions: readonly string[],
): NavGroup[] {
    return groups
        .map((group) => ({
            ...group,
            items: group.items.filter(
                (item) =>
                    item.requiresPermission === undefined ||
                    permissions.includes(item.requiresPermission),
            ),
        }))
        .filter((group) => group.items.length > 0);
}
